import { Col, Row } from 'react-bootstrap'
import { useBreakpoint } from '../../../hooks'

import useContainerContext from '../../containerContext'
import { RecordInfoMobile, RecordInfoDesktop } from '../../RecodeInfo'
import { VehicleMobile, VehicleDesktop } from '../../vehicle'
import CompanyInfo from '../../companyInfo'
import GroupButton from './groupButton'
import ModalPaymentInfo from '../../paymentInfo'
import ModalReceipt from '../../paymentInfo/receipt'
import ModalPhotoList from '../../ModalPhotoList'

const InvoiceDetail = () => {
	const { data, state, showPhotoModal, closeModalPhoto } = useContainerContext()
	const { showModalPhoto, vehicle, initialSlide, isPayment, isReceipt } = state
	const { company, vehicles = [] } = data
	const { BREAKPOINT, screenBiggerThan } = useBreakpoint()
	const isBiggerThanMD = screenBiggerThan(BREAKPOINT.MD)

	return (
		<div className='my-5 px-sm-3'>
			<Row>
				<Col md={8}>
					<CompanyInfo company={company} isBiggerThanMD={isBiggerThanMD} />
				</Col>
				<Col sm={8} md={4} className='mx-auto'>
					<GroupButton isBiggerThanMD={isBiggerThanMD} />
				</Col>
			</Row>

			<Row>
				<Col md={12}>
					{isBiggerThanMD && (
						<div className='pt-4'>
							<div className='mt-4 py-4 bg-white shadow-lg rounded'>
								<RecordInfoDesktop record={data} isInvoice={true} />
								{vehicles.map((vehicle, index) => {
									return <VehicleDesktop key={index} index={index.toString()} vehicle={vehicle} onShowPhoto={showPhotoModal} />
								})}
							</div>
						</div>
					)}
					{!isBiggerThanMD && (
						<div className='mt-4 py-4 bg-white shadow-lg'>
							<RecordInfoMobile record={data} isInvoice={true} />

							{vehicles.map((vehicle, index) => {
								return <VehicleMobile key={index} index={index.toString()} vehicle={vehicle} onShowPhoto={showPhotoModal} />
							})}
						</div>
					)}
				</Col>
			</Row>

			{isPayment && <ModalPaymentInfo data={data} />}
			{isReceipt && <ModalReceipt />}
			{showModalPhoto && <ModalPhotoList vehicle={vehicle} initialSlide={initialSlide} onClose={closeModalPhoto} isInvoice={true} />}
		</div>
	)
}
export default InvoiceDetail
